import React, { useState } from "react";
import {
  Button,
  TextField,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
} from "@mui/material";
import {
  generatedPdfForAll,
  generatedPdfForLocation,
  generatedPdfForSpecility,
} from "../../api/api";
import toast from "react-hot-toast";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const OPdListPdf = ({ onclose, doctors, location }) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const [buttonType, setButtonType] = useState("All");
  const [locations, setLocations] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [selectedCenterIds, setSelectedCenterIds] = useState([]);
  const [selectedSpecialityIds, setSelectedSpecialityIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPdfDataforAll = async () => {
    try {
      const payload = { get_centerId: "all", offLoader: true };
      const res = await generatedPdfForAll(payload);
      console.log("PDF data fetched:", res);
      return res;
    } catch (err) {
      console.error("Error fetching PDF data:", err);
    }
  };

  const fetchPdfDataforSpeciality = async () => {
    const payload = {
      offLoader: true,
      get_pdfspecialityId: selectedSpecialityIds.join(","),
    };
    try {
      const res = await generatedPdfForSpecility(payload);
      console.log("PDF data fetched:", res);
      return res;
    } catch (err) {
      console.error("Error fetching PDF data:", err);
    }
  };

  const fetchPdfDataforLocation = async () => {
    const payload = {
      offLoader: true,
      get_centerId: selectedCenterIds.join(","),
    };
    try {
      console.log("Payload for location PDF:", payload); // Debug log
      const res = await generatedPdfForLocation(payload);
      console.log("PDF data fetched:", res);
      return res;
    } catch (err) {
      console.error("Error fetching PDF data:", err);
    }
  };

  //   const handleDownload = async () => {
  //   try {
  //     let res;

  //     if (buttonType === "All") {
  //       res = await fetchPdfDataforAll();
  //     } else if (buttonType === "By Preferred Location") {
  //       if (selectedCenterIds.length === 0) {
  //         toast.error("Please select at least one location.");
  //         return;
  //       }
  //       res = await fetchPdfDataforLocation();
  //     } else if (buttonType === "By Speciality") {
  //       if (selectedSpecialityIds.length === 0) {
  //         toast.error("Please select at least one speciality.");
  //         return;
  //       }
  //       res = await fetchPdfDataforSpeciality();
  //     }

  //     const pdfUrl =
  //       res?.data?.doctorDetails || res?.data?.path;

  //     if (pdfUrl) {

  //       window.open(pdfUrl, "_blank");

  //       const link = document.createElement("a");
  //       link.href = pdfUrl;
  //       link.download = "RB_Doctors_List.pdf";
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);

  //       toast.success("PDF generated successfully!");
  //     } else {
  //       toast.error("Failed to generate PDF. Please try again.");
  //       console.error("No PDF URL found in response:", res);
  //     }
  //   } catch (error) {
  //     console.error("Error while downloading PDF:", error);
  //     toast.error("Something went wrong while downloading.");
  //   }
  // };

  const handleDownload = async () => {
    try {
      setLoading(true); // start loader
      let res;

      if (buttonType === "All") {
        res = await fetchPdfDataforAll();
      } else if (buttonType === "By Preferred Location") {
        if (selectedCenterIds.length === 0) {
          toast.error("Please select at least one location.");
          setLoading(false);
          return;
        }
        res = await fetchPdfDataforLocation();
      } else if (buttonType === "By Speciality") {
        if (selectedSpecialityIds.length === 0) {
          toast.error("Please select at least one speciality.");
          setLoading(false);
          return;
        }
        res = await fetchPdfDataforSpeciality();
      }

      // Normalize URL
      const pdfUrl = res?.data?.doctorDetails || res?.data?.path;

      if (pdfUrl) {
        // 1️⃣ Force direct download only (NO duplicate!)
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "RB_Doctors_List.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("PDF downloaded!");
      } else {
        toast.error("Failed to generate PDF.");
        console.error("Missing URL:", res);
      }
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false); // stop loader
    }
  };

  const speciality = Array.from(
    new Map(
      doctors.map((doc) => [
        doc.specialization_id,
        { id: doc.specialization_id, name: doc.specialization },
      ])
    ).values()
  ).sort((a, b) => a - b);

  const locationOptions = Array.from(
    new Map(
      location.map((doc) => [
        doc.center_id,
        { id: doc.center_id, name: doc.center_name },
      ])
    ).values()
  );

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "650px",
          width: "100%",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          position: "relative",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
            paddingBottom: "10px",
            marginBottom: "20px",
          }}
        >
          <h2 style={{ margin: 0, color: "#0ca798" }}>
            DOWNLOAD RB DOCTOR'S LIST
          </h2>
          <button
            onClick={onclose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Radio Buttons */}
        <FormControl component="fieldset" style={{ width: "100%" }}>
          <RadioGroup
            row
            name="buttonType"
            value={buttonType}
            onChange={(e) => setButtonType(e.target.value)}
            style={{ justifyContent: "center" }}
          >
            {["All", "By Preferred Location", "By Speciality"].map((type) => (
              <FormControlLabel
                key={type}
                value={type}
                control={<Radio sx={{ transform: "scale(1.3)" }} />}
                label={type}
                sx={{ marginRight: "30px", fontSize: "18px" }}
              />
            ))}
          </RadioGroup>
        </FormControl>

        {/* Dropdown for Preferred Location */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          {buttonType === "By Preferred Location" && (
            <div
              style={{ marginTop: "20px", maxWidth: "400px", width: "100%" }}
            >
              <Typography
                variant="h6"
                style={{
                  marginBottom: "10px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                Select Preferred Location
              </Typography>

              <Autocomplete
                multiple
                options={locationOptions}
                disableCloseOnSelect
                getOptionLabel={(option) => option.name}
                value={locationOptions.filter((opt) =>
                  selectedCenterIds.includes(opt.id)
                )}
                onChange={(e, newValue) => {
                  setSelectedCenterIds(newValue.map((item) => item.id));
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Preferred Location" />
                )}
                style={{ width: "100%" }}
              />
            </div>
          )}
        </div>

        {/* Dropdown for Speciality */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          {buttonType === "By Speciality" && (
            <div
              style={{ marginTop: "20px", maxWidth: "400px", width: "100%" }}
            >
              <Typography
                variant="h6"
                style={{
                  marginBottom: "10px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                Select Preferred Speciality
              </Typography>
              <Autocomplete
                multiple
                options={speciality}
                disableCloseOnSelect
                getOptionLabel={(option) => option.name}
                value={speciality.filter((opt) =>
                  selectedSpecialityIds.includes(opt.id)
                )}
                onChange={(e, newValue) => {
                  setSelectedSpecialityIds(newValue.map((item) => item.id));
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Speciality" />
                )}
                style={{ width: "100%" }}
              />
            </div>
          )}
        </div>

        {loading && (
          <div
            style={{ marginTop: "20px", width: "100%", textAlign: "center" }}
          >
            <Typography
              variant="body1"
              style={{ marginBottom: "10px", fontWeight: 500 }}
            >
              Preparing your PDF...
            </Typography>

            {/* Progress Bar Wrapper */}
            <div
              style={{
                width: "80%",
                height: "8px",
                background: "#e0e0e0",
                borderRadius: "10px",
                margin: "0 auto",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/* Moving Bar Fill */}
              <div
                style={{
                  width: "40%",
                  height: "100%",
                  background: "#0ca798",
                  position: "absolute",
                  animation: "loadingAnim 1.2s linear infinite",
                }}
              ></div>
            </div>
          </div>
        )}

        {/* Download Button */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          <Button
            variant="contained"
            style={{
              backgroundColor: "#0ca798",
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "6px",
            }}
            onClick={handleDownload}
          >
            Click here to Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OPdListPdf;
